import React from 'react'
import * as S from './styled'
import { IconArrowRight } from '../iconArrowRight'

export const ButtonDasa = ({ text, color, link = null, onAction }) => {
  return (
    <>
      {link ? (
        <S.ButtonDasaLink to={link} onClick={onAction && (() => onAction())}>
          <button bg={color}>
            {text} <IconArrowRight size={20} color={'#f5f5f5'} />
          </button>
        </S.ButtonDasaLink>
      ) : (
        <S.ButtonDasa bg={color} onClick={onAction && (() => onAction())}>
          {text} <IconArrowRight size={20} color={'#f5f5f5'} />
        </S.ButtonDasa>
      )}
    </>
  )
}
